import React from "react"
import PropTypes from "prop-types"

import Button from "components/Button/Button"

import styles from "./PageActionsStyle.css"
import i18n from "consts/i18n"
import classNames from "classnames"

const generateBtnLabel = (label, isProgramAvailable) => {
  if (label) {
    return label
  }

  if (isProgramAvailable) {
    return i18n.deepLinkPage.watchNow
  }

  return i18n.deepLinkPage.programUnavailableBtn
}

const PageActions = ({ children, isShown = true, onClick, isProgramAvailable = true, label, withGradientBackground = true }) => {
  const btnLabel = generateBtnLabel(label, isProgramAvailable)

  return (
    <div className={styles.container}>
      {children}
      <div
        className={classNames(styles.sticky, {
          [styles.hidden]: !isShown,
          [styles.withGradientBackground]: withGradientBackground,
        })}
      >
        <Button
          color={Button.colors.yellowFull}
          customStyle={styles.button}
          icon={
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.5 19.53V4.59482C6.5 4.02469 6.97777 3.5625 7.56712 3.5625C7.76053 3.5625 7.9503 3.61335 8.11615 3.70961L20.9817 11.1772C21.4871 11.4705 21.651 12.1047 21.3478 12.5935C21.2576 12.7388 21.1319 12.8604 20.9817 12.9476L8.11615 20.4152C7.61078 20.7086 6.95529 20.55 6.65207 20.0611C6.55256 19.9007 6.5 19.7171 6.5 19.53Z"
                fill="black"
              />
            </svg>
          }
          value={btnLabel}
          onClick={onClick}
        />
      </div>
    </div>
  )
}

PageActions.propTypes = {
  isShown: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
  isProgramAvailable: PropTypes.bool,
  label: PropTypes.string,
  withGradientBackground: PropTypes.bool,
}

export default PageActions
